import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const TermsPage = () => {
  const sections = [
    {
      title: "1. INFORMATII GENERALE",
      content: `Bine ati venit pe DEPRO KICKS. Prin accesarea si utilizarea website-ului nostru, acceptati si sunteti de acord sa respectati acesti termeni si conditii. DEPRO KICKS este un magazin online de sneakers premium, specializat in incaltaminte de calitate superioara, inclusiv modele Yeezy, Louboutin si Alexander McQueen.

Acesti termeni se aplica tuturor vizitatorilor, utilizatorilor si clientilor website-ului.`
    },
    {
      title: "2. PRODUSE SI INFORMATII DESPRE PRODUSE",
      content: `Toate produsele comercializate pe DEPRO KICKS sunt originale si de calitate premium. Ne straduim sa prezentam informatii cat mai accurate despre produse, inclusiv imagini, descrieri si specificatii.

Cu toate acestea, culorile produselor pot varia usor in functie de setarile monitorului dumneavoastra. Recomandam consultarea ghidului de marimi pentru a alege marimea corecta.

Ne rezervam dreptul de a modifica sau intrerupe vanzarea oricarui produs fara notificare prealabila.`
    },
    {
      title: "3. COMENZI",
      content: `Comenzile pot fi plasate prin intermediul website-ului nostru 24/7. Plasarea unei comenzi reprezinta o oferta de cumparare din partea dumneavoastra.

Confirmarea comenzii va fi trimisa pe adresa de email furnizata. Comanda este considerata acceptata doar dupa primirea confirmarii de la DEPRO KICKS.

Ne rezervam dreptul de a refuza sau anula orice comanda din motive precum: indisponibilitatea produselor, erori de pret, suspiciuni de frauda sau alte circumstante exceptionale.`
    },
    {
      title: "4. PRETURI SI PLATA",
      content: `Toate preturile afisate sunt in Lei Romanesti (RON) si includ TVA acolo unde este aplicabil.

Metodele de plata acceptate sunt:
• Card de credit/debit (prin Stripe - plata securizata)
• Plata la livrare (ramburs) - cu posibilitatea de a verifica coletul inainte de plata

Preturile pot fi modificate in orice moment fara notificare prealabila. Pretul aplicabil este cel afisat in momentul plasarii comenzii.`
    },
    {
      title: "5. LIVRARE",
      content: `Oferim livrare gratuita pe intreg teritoriul Romaniei.

Timpul estimat de livrare este de 2-4 zile lucratoare. Comenzile sunt procesate in 1-2 zile lucratoare dupa confirmarea platii sau plasarea comenzii cu plata la livrare.

Colaboram cu curierii de incredere: Fan Courier, Sameday si Cargus. Veti primi un email cu informatiile de tracking dupa expedierea comenzii.

DEPRO KICKS nu este responsabil pentru intarzierile cauzate de serviciile de curierat sau de circumstante neprevazute.`
    },
    {
      title: "6. RETURURI SI RAMBURSARI",
      content: `In conformitate cu OUG 34/2014, aveti dreptul de a returna produsele in termen de 14 zile calendaristice de la primire, fara a fi necesara oferirea unui motiv.

Conditii pentru retur:
• Produsele trebuie sa fie in starea originala, nefolosite si cu etichetele intacte
• Ambalajul original trebuie pastrat
• Returnarea se face pe cheltuiala cumparatorului

Pentru a initia un retur, va rugam sa ne contactati prin WhatsApp la +40 759 649 614 sau prin pagina de Contact.

Rambursarea se efectueaza in termen de 14 zile de la primirea produselor returnate, folosind aceeasi metoda de plata utilizata la cumparare.`
    },
    {
      title: "7. DISPONIBILITATEA PRODUSELOR",
      content: `Disponibilitatea produselor este supusa nivelurilor de stoc si poate fi modificata fara notificare. Desi facem eforturi pentru a mentine informatiile despre stoc actualizate, pot exista situatii in care un produs devine indisponibil dupa plasarea comenzii.

In astfel de cazuri, va vom contacta pentru a va oferi alternative sau pentru a procesa rambursarea.`
    },
    {
      title: "8. RESPONSABILITATILE CLIENTULUI",
      content: `Prin utilizarea website-ului si plasarea comenzilor, va angajati sa:
• Furnizati informatii corecte si complete pentru livrare
• Utilizati website-ul in mod legal si conform acestor termeni
• Nu utilizati website-ul pentru activitati frauduloase
• Nu incalcati drepturile de proprietate intelectuala ale DEPRO KICKS

Sunteti responsabil pentru pastrarea confidentialitatii informatiilor contului dumneavoastra.`
    },
    {
      title: "9. PROPRIETATE INTELECTUALA",
      content: `Tot continutul de pe acest website, inclusiv texte, grafice, logo-uri, imagini, fotografii si design, este proprietatea DEPRO KICKS si este protejat de legile drepturilor de autor si ale proprietatii intelectuale.

Utilizarea neautorizata a oricarui continut este strict interzisa si poate duce la actiuni legale.

Marcile comerciale mentionate pe website (inclusiv Yeezy, Adidas, Louboutin, Alexander McQueen) apartin respectivilor proprietari si sunt folosite doar in scop informativ.`
    },
    {
      title: "10. PROTECTIA DATELOR SI CONFIDENTIALITATE",
      content: `DEPRO KICKS colecteaza si proceseaza datele personale in conformitate cu Regulamentul General privind Protectia Datelor (GDPR) si legislatia romaneasca in vigoare.

Datele colectate sunt utilizate exclusiv pentru:
• Procesarea si livrarea comenzilor
• Comunicarea cu clientii
• Imbunatatirea serviciilor noastre

Nu vindem, inchiriem sau partajam datele personale cu terte parti, cu exceptia partenerilor de livrare necesari pentru indeplinirea comenzilor.`
    },
    {
      title: "11. LIMITAREA RASPUNDERII",
      content: `DEPRO KICKS nu este responsabil pentru:
• Daune indirecte, accidentale sau consecvente rezultate din utilizarea produselor
• Intarzieri sau erori cauzate de furnizori terti (curierat, procesatori de plati)
• Indisponibilitatea temporara a website-ului din motive tehnice

Raspunderea maxima a DEPRO KICKS este limitata la valoarea produsului achizitionat.`
    },
    {
      title: "12. MODIFICARI ALE TERMENILOR SI CONDITIILOR",
      content: `DEPRO KICKS isi rezerva dreptul de a modifica acesti termeni si conditii in orice moment. Modificarile intra in vigoare imediat dupa publicarea pe website.

Continuarea utilizarii website-ului dupa modificari constituie acceptarea noilor termeni.

Va recomandam sa verificati periodic aceasta pagina pentru a fi la curent cu eventualele modificari.`
    },
    {
      title: "13. LEGEA APLICABILA SI JURISDICTIA",
      content: `Acesti termeni si conditii sunt guvernati de legislatia romana in vigoare.

Orice disputa va fi solutionata pe cale amiabila. In cazul in care nu se ajunge la o intelegere, disputele vor fi supuse instantelor competente din Romania.`
    },
    {
      title: "14. CONTACT",
      content: `Pentru orice intrebari sau nelămuriri privind acesti termeni si conditii, ne puteti contacta:

WhatsApp: +40 759 649 614
Email: contact@deprokicks.com

Programul de suport: Luni - Vineri, 09:00 - 18:00`
    }
  ];

  return (
    <>
      <Helmet>
        <title>Termeni si Conditii | DEPRO KICKS</title>
        <meta name="description" content="Termeni si conditii pentru achizitiile de pe DEPRO KICKS. Informatii despre comenzi, livrare, retururi si politica de confidentialitate." />
      </Helmet>
      
      <div className="min-h-screen bg-[#0a0a0a]">
        {/* Header */}
        <div className="py-24 px-6 md:px-12 lg:px-24 border-b border-white/5">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="flex items-center gap-2 font-body text-sm text-white/50 mb-6">
              <Link to="/" className="hover:text-white transition-colors">Acasa</Link>
              <ChevronRight className="w-4 h-4" />
              <span className="text-white">Termeni si Conditii</span>
            </div>
            
            <h1 className="font-heading font-bold text-4xl md:text-6xl tracking-tight uppercase text-white" data-testid="terms-title">
              TERMENI SI CONDITII
            </h1>
            <p className="font-body text-white/50 mt-4 max-w-2xl">
              Va rugam sa cititi cu atentie acesti termeni si conditii inainte de a utiliza website-ul sau de a plasa o comanda.
            </p>
          </motion.div>
        </div>

        {/* Content */}
        <div className="px-6 md:px-12 lg:px-24 py-16">
          <div className="max-w-4xl space-y-12">
            {sections.map((section, index) => (
              <motion.section
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
              >
                <h2 className="font-heading font-bold text-xl tracking-wider text-white mb-4">
                  {section.title}
                </h2>
                <div className="font-body text-white/70 leading-relaxed whitespace-pre-line">
                  {section.content}
                </div>
              </motion.section>
            ))}

            {/* Last Updated */}
            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7 }}
              className="pt-8 border-t border-white/5"
            >
              <p className="font-body text-sm text-white/40">
                Ultima actualizare: Ianuarie 2025
              </p>
            </motion.section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPage;
